import * as React from 'react';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import { hospitalActions, userActions } from '../../../_actions';
import { useDispatch, useSelector } from 'react-redux';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
  p: 4,
};


export default function AddDoctorModel({ addDocotor, closeDialog }) {
  const selector = useSelector(state => state)
  let dispatch = useDispatch();

  const [fieldsUser, setFieldsUser] = React.useState({});
  const [error, setErrors] = React.useState({});
  const handleClose = () => {
    setFieldsUser({})
    dispatch(hospitalActions.uploadImageClear())
    dispatch(hospitalActions.clearimage())
    setErrors({})
    closeDialog()
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFieldsUser((prevFields) => ({ ...prevFields, [name]: value }));
    setErrors({ ...error, [name]: "" })
  };

  const handleValidationUserInfo = () => {
    let formIsValid = true;
    let newErrors = {};
    const specialCharacterRegex = /[!@#$%^&*(),.?":{}|<>]/;
    // name
    if (!fieldsUser.name) {
      formIsValid = false;
      newErrors = { ...newErrors, name: 'Enter name' };
    }


    // title
 


    // mobNo
    // if (!fieldsUser.mobNo) {
    //   formIsValid = false;
    //   newErrors = { ...newErrors, mobNo: 'Enter mobile number' };
    // }
    // if (!fieldsUser.Degree) {
    //   formIsValid = false;
    //   newErrors = { ...newErrors, Degree: 'Enter Qualification' };
    // }

    // if (!fieldsUser.expireance) {
    //   formIsValid = false;
    //   newErrors = { ...newErrors, expireance: 'Enter expireance' };
    // }
    // if (!fieldsUser.position) {
    //   formIsValid = false;
    //   newErrors = { ...newErrors, position: 'Enter position' };
    // }



    // aboutUs
    // if (!fieldsUser.aboutUs) {
    //   formIsValid = false;
    //   newErrors = { ...newErrors, aboutUs: 'Enter about us' };
    // }

    setErrors(newErrors);
    return formIsValid;
  };

  const submitDetails = (e) => {
    e.preventDefault();
    if (handleValidationUserInfo()) {


     
      dispatch(hospitalActions.addHospitalDr({
        ...fieldsUser, specializationId: fieldsUser.specializationId
        , profileImg: selector && selector.users.filesDetails?.imageName,title:" "
      }));
      dispatch(hospitalActions.clearimage())
      setFieldsUser({})
      closeDialog()
    }
  };

  let handleSubmitImage = async (e) => {
    e.preventDefault()
    dispatch(hospitalActions.uploadImage({ image: e.target.files[0] }))
  }

  // console.log(selector)
  return (

    <div  >
      {/* <Button onClick={handleOpen}>Open modal</Button> */}
      <Modal
        open={addDocotor}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 lg:w-[700px] w-11/12 mx-auto bg-white rounded-lg shadow-xl p-4">




          <div className='flex justify-between p-2 bg-[#005F60] rounded-lg text-white'>
            <div>Add Doctor</div>
            <CloseIcon onClick={() => handleClose()} className=' cursor-pointer' />
          </div>
          <form className="grid lg:grid-cols-2 grid-cols-1 gap-4 h-[400px] overflow-y-auto py-4">


            {/* <div>
              <label htmlFor="title" className="block text-sm font-medium text-gray-700">
                Title
              </label>
              <select
                id="title"
                name="title"
                className={`mt-1 bg-white p-2 w-full rounded-md border ${error.title ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:border-blue-500`}
                value={fieldsUser.title}
                onChange={handleChange}
              >
                <option value="">Select Title</option>
                <option value="Dr.">Dr.</option>
                <option value="Mr.">Mr.</option>
                <option value="Mrs.">Mrs.</option>
                <option value="Ms.">Ms.</option>
             
              </select>
              {error['title'] && <p className='text-sm text-red-500'>{error.title}</p>}
            </div> */}

            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                Dr. Name
              </label>
              <input
                id="name"
                name="name"
                type="text"
                placeholder="Enter Name"
                className={`mt-1 p-2 w-full rounded-md border ${error.name ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:border-blue-500`}
                value={fieldsUser.name || ''}
                onChange={handleChange}
              />
              {error['name'] && <p className='text-sm text-red-500'>{error.name}</p>}
            </div>

            <div>
              <label htmlFor="mobNo" className="block text-sm font-medium text-gray-700">
                Mobile Number
              </label>
              <input
                id="mobNo"
                name="mobNo"
                type="number"
                placeholder="Enter Mobile Number"
                className={`mt-1 p-2 w-full rounded-md border ${error.mobNo ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:border-blue-500`}
                value={fieldsUser.mobNo || ''}
                onChange={handleChange}
              />
              {error['mobNo'] && <p className='text-sm text-red-500'>{error.mobNo}</p>}
            </div>


            <div>
              <label htmlFor="alternateNo" className="block text-sm font-medium text-gray-700">
                Alternate Number
              </label>
              <input
                id="alternateNo"
                name="alternateNo"
                type="number"
                placeholder="Enter Alternate Number"
                className={`mt-1 p-2 w-full rounded-md border ${error.alternateNo ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:border-blue-500`}
                value={fieldsUser.alternateNo || ''}
                onChange={handleChange}
              />
              {error['alternateNo'] && <p className='text-sm text-red-500'>{error.alternateNo}</p>}
            </div>

            <div>
              <label htmlFor="Degree" className="block text-sm font-medium text-gray-700">
              Qualification

              </label>
              <textarea
              rows={1}
                id="Degree"
                name="Degree"
                type="text"
                placeholder="Enter Qualification"
                className={`mt-1 p-2 w-full rounded-md border ${error.Degree ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:border-blue-500`}
                value={fieldsUser.Degree || ''}
                onChange={handleChange}
              />
              {error['Degree'] && <p className='text-sm text-red-500'>{error.Degree}</p>}
            </div>

            <div>
              <label htmlFor="expireance" className="block text-sm font-medium text-gray-700">
                Expireance
              </label>
              <input
                id="expireance"
                name="expireance"
                type="text"
                placeholder="Enter Expereance"
                className={`mt-1 p-2 w-full rounded-md border ${error.expireance ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:border-blue-500`}
                value={fieldsUser.expireance || ''}
                onChange={handleChange}
              />
              {error['expireance'] && <p className='text-sm text-red-500'>{error.expireance}</p>}
            </div>

            <div>
              <label htmlFor="position" className="block text-sm font-medium text-gray-700">
                Position
              </label>
              <input
                id="position"
                name="position"
                type="text"
                placeholder="Enter Alternate Number"
                className={`mt-1 p-2 w-full rounded-md border ${error.position ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:border-blue-500`}
                value={fieldsUser.position || ''}
                onChange={handleChange}
              />
              {error['position'] && <p className='text-sm text-red-500'>{error.position}</p>}
            </div>

            {/* <div>
              <label htmlFor="specializationId" className="block text-sm font-medium text-gray-700">
                Specialization
              </label>
              <select
                id="specializationId"
                name="specializationId"
                className={`mt-1 p-2 bg-white w-full rounded-md border ${error.specializationId ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:border-blue-500`}
                value={fieldsUser.specializationId}
                onChange={handleChange}
              >
                <option value="">Select Specialization</option>
                {selector?.hospital?.specializationid?.SpecializationId.map((e) => (

                  <option key={e.id} value={e.id}>{e?.name}</option>
                ))}


            
              </select>
              {error['SpecializationId'] && <p className='text-sm text-red-500'>{error.SpecializationId}</p>}
            </div> */}
            <div className='lg:col-span-2'>
              <label htmlFor="aboutUs" className="block text-sm font-medium text-gray-700">
                About Us
              </label>
              <textarea
                id="aboutUs"
                name="aboutUs"
                type="text"
                placeholder="Enter About Us"
                className={`mt-1 p-2 w-full rounded-md border ${error.aboutUs ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:border-blue-500`}
                value={fieldsUser.aboutUs || ''}
                onChange={handleChange}
              />
              {error['aboutUs'] && <p className='text-sm text-red-500'>{error.aboutUs}</p>}
            </div>






            <div className='flex gap-3 items-center justify-between'>
              <div>
                <label htmlFor="ProfileImage" className="block text-sm font-medium text-gray-700">
                  Profile Image
                </label>
                <input
                  id="ProfileImage"
                  name="ProfileImage"
                  type="file"
                  placeholder="Enter About Us"
                  className={`mt-1 p-2 w-full rounded-md border ${error.ProfileImage ? 'border-red-500' : 'border-gray-300'
                    } focus:outline-none focus:border-blue-500`}
                  // value={fieldsUser.ProfileImage || ''}
                  onChange={(e) => handleSubmitImage(e)}
                />
                {error['ProfileImage'] && <p className='text-sm text-red-500'>{error.ProfileImage}</p>}
              </div>
              <img className=' w-20 h-20' src={selector && selector.users.filesDetails?.imageUrl || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"} />
            </div>


          </form>
          <div className='flex justify-center items-center pt-4'>
            <button
              onClick={submitDetails}
              type="button"
              className="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#005F60] focus:outline-none focus:ring-2 focus:ring-offset-2 w-40 mx-auto text-center"
            >
              Submit
            </button>

          </div>
        </div>
      </Modal>
    </div>
  );
}





















